/* Pack Tank Top Mamá & Hija — Ochi and Co — 2026-04-27 */
(function () {
  var section = document.querySelector('[data-pack-tt]');
  if (!section) return;

  var dataNode = section.querySelector('[data-pack-data]');
  var DATA;
  try { DATA = JSON.parse(dataNode.textContent); }
  catch (e) { console.error('Pack TT data error', e); return; }

  var state = {
    adultType: 'normals',     // 'normals' | 'halters'
    adultProduct: null,        // product object
    adultVariant: null,
    littleProduct: null,
    littleVariant: null
  };

  var cta = section.querySelector('[data-cta]');
  var feedback = section.querySelector('[data-feedback]');
  var priceAdult = section.querySelector('[data-price-adult]');
  var priceLittle = section.querySelector('[data-price-little]');
  var priceTotal = section.querySelector('[data-price-total]');

  function money(cents) {
    var n = Math.round(cents / 100);
    return '$' + n.toLocaleString('es-CL');
  }

  // Algunos themes ya tienen el price en cents (dividido por 100), otros no.
  // Shopify variant.price suele venir en cents (ej: 30990 = $309,90 NO. En CLP es entero).
  // En Chile: $30.990 viene como 3099000 cents O como 30990 (depende de la API).
  // Para ser robusto: si el precio es < 1000, asumir que está en cents/100. Si >= 1000, asumir entero CLP.
  function fmt(p) {
    if (!p && p !== 0) return '—';
    // Shopify liquid devuelve price en cents (CLP × 100). Dividimos por 100.
    var n = Math.round(parseInt(p, 10) / 100);
    return '$' + n.toLocaleString('es-CL');
  }

  function setMsg(txt, isErr) {
    feedback.textContent = txt || '';
    feedback.classList.toggle('is-error', !!isErr);
  }

  function colorNameFromTitle(title) {
    // "Tank top - Negro borde crudo" → "Negro borde crudo"
    // "Tank top halter - Crudo borde azul" → "Crudo borde azul"
    // "Little tank top - Burdeo borde crudo" → "Burdeo borde crudo"
    var t = title;
    var m = t.match(/(?:tank top(?: halter)?|little tank top)\s*[-–]\s*(.+)/i);
    if (m) return m[1].trim();
    return t;
  }

  // Normaliza nombres de talla para comparar entre productos.
  // Algunos productos guardan "Small/Medium/Large" y otros "S/M/L".
  function normalizeSize(s) {
    if (!s) return s;
    var t = s.toString().trim().toLowerCase();
    if (t === 'small') return 'S';
    if (t === 'medium') return 'M';
    if (t === 'large') return 'L';
    if (t === 'extra small' || t === 'x-small' || t === 'xs') return 'XS';
    if (t === 'extra large' || t === 'x-large' || t === 'xl') return 'XL';
    return s.toString().trim().toUpperCase();
  }

  function renderColors(piece) {
    var container = section.querySelector('[data-colors="' + piece + '"]');
    container.innerHTML = '';
    var products = (piece === 'adult') ? DATA[state.adultType] : DATA.littles;

    products.forEach(function (p) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pack-tt-color-btn';
      btn.setAttribute('data-product-id', p.id);
      btn.setAttribute('data-tooltip', colorNameFromTitle(p.title));
      btn.setAttribute('aria-label', colorNameFromTitle(p.title));
      var img = '';
      if (p.image) img = '<img src="' + p.image + '" alt="' + p.title + '">';
      btn.innerHTML = img;
      btn.addEventListener('click', function () { selectColor(piece, p, btn); });
      container.appendChild(btn);
    });
  }

  function selectColor(piece, product, btn) {
    var container = section.querySelector('[data-colors="' + piece + '"]');
    container.querySelectorAll('.pack-tt-color-btn').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    if (piece === 'adult') {
      state.adultProduct = product;
      state.adultVariant = null;
    } else {
      state.littleProduct = product;
      state.littleVariant = null;
    }
    var colorLabel = section.querySelector('[data-piece-color="' + piece + '"]');
    if (colorLabel) colorLabel.textContent = colorNameFromTitle(product.title);
    updateSizesForColor(piece, product);
    updateUI();
  }

  function getAllSizes(piece) {
    if (piece === 'adult') return ['S', 'M', 'L'];
    var sizes = [];
    var seen = {};
    DATA.littles.forEach(function (p) {
      p.variants.forEach(function (v) {
        if (!seen[v.size]) {
          seen[v.size] = true;
          sizes.push(v.size);
        }
      });
    });
    return sizes;
  }

  function renderAllSizes(piece) {
    var container = section.querySelector('[data-sizes="' + piece + '"]');
    container.innerHTML = '';
    getAllSizes(piece).forEach(function (size) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pack-tt-size-btn';
      btn.setAttribute('data-size', size);
      btn.setAttribute('data-state', 'no-color');
      btn.textContent = size;
      btn.addEventListener('click', function () { handleSizeClick(piece, size, btn); });
      container.appendChild(btn);
    });
    var bis = section.querySelector('[data-bis="' + piece + '"]');
    if (bis) bis.hidden = true;
  }

  function updateSizesForColor(piece, product) {
    var container = section.querySelector('[data-sizes="' + piece + '"]');
    var btns = container.querySelectorAll('.pack-tt-size-btn');
    btns.forEach(function (btn) {
      var size = btn.getAttribute('data-size');
      var v = product.variants.find(function (x) { return normalizeSize(x.size) === size; });
      btn.classList.remove('is-selected');
      if (v && v.available) {
        btn.setAttribute('data-variant-id', v.id);
        btn.setAttribute('data-state', 'available');
      } else if (v && !v.available) {
        btn.setAttribute('data-variant-id', v.id);
        btn.setAttribute('data-state', 'soldout');
      } else {
        btn.removeAttribute('data-variant-id');
        btn.setAttribute('data-state', 'not-in-color');
      }
    });
    var bis = section.querySelector('[data-bis="' + piece + '"]');
    if (bis) bis.hidden = true;
  }

  function handleSizeClick(piece, size, btn) {
    var prod = (piece === 'adult') ? state.adultProduct : state.littleProduct;
    if (!prod) {
      setMsg('Elegí primero un color de ' + (piece === 'adult' ? 'mamá' : 'hija') + '.', false);
      return;
    }
    var v = prod.variants.find(function (x) { return normalizeSize(x.size) === size; });
    if (!v) return;
    selectSize(piece, v, btn);
  }

  function selectSize(piece, variant, btn) {
    var container = section.querySelector('[data-sizes="' + piece + '"]');
    container.querySelectorAll('.pack-tt-size-btn').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    if (piece === 'adult') state.adultVariant = variant;
    else state.littleVariant = variant;
    var bis = section.querySelector('[data-bis="' + piece + '"]');
    if (!variant.available) {
      var bisBtn = bis.querySelector('.klaviyo-bis-trigger');
      bisBtn.setAttribute('data-variant-id', variant.id);
      var prod = (piece === 'adult') ? state.adultProduct : state.littleProduct;
      if (prod) bisBtn.setAttribute('data-product-id', prod.id);
      bis.hidden = false;
    } else {
      bis.hidden = true;
    }
    updateUI();
  }

  function updateUI() {
    var t = state.adultVariant, b = state.littleVariant;
    var adultPrice = t ? parseInt(t.price, 10) : 0;
    var littlePrice = b ? parseInt(b.price, 10) : 0;
    // discount_amount viene en CLP (4990). Los prices vienen en cents (CLP × 100).
    // Convertir el descuento a cents para sumar/restar consistentemente.
    var discount = (DATA.config.discount_amount || 4990) * 100;
    var littleAfter = b ? Math.max(0, littlePrice - discount) : 0;
    var total = adultPrice + littleAfter;

    priceAdult.textContent = t ? fmt(adultPrice) : '—';
    if (b) {
      priceLittle.innerHTML = '<span class="pack-tt-discount-tag">' + fmt(littlePrice) + '</span>' + fmt(littleAfter);
    } else {
      priceLittle.textContent = '—';
    }
    priceTotal.textContent = (t && b) ? fmt(total) : '—';

    if (t && b && t.available && b.available) {
      cta.disabled = false;
      cta.textContent = 'Llevar el pack';
      setMsg('');
    } else if ((t && !t.available) || (b && !b.available)) {
      cta.disabled = true;
      cta.textContent = 'Talla no disponible';
      setMsg('Una de las tallas no está disponible. Podés pedir aviso cuando vuelva.');
    } else {
      cta.disabled = true;
      cta.textContent = 'Elige tipo y tallas';
      setMsg('');
    }
  }

  // Galería mobile: carrusel swipe + thumbnails sincronizados
  var mobileCarousel = section.querySelector('[data-mobile-carousel]');
  var mobileThumbs = section.querySelectorAll('[data-mobile-thumb]');
  if (mobileCarousel && mobileThumbs.length) {
    mobileCarousel.addEventListener('scroll', function () {
      var idx = Math.round(mobileCarousel.scrollLeft / mobileCarousel.clientWidth);
      mobileThumbs.forEach(function (t, i) {
        t.classList.toggle('is-selected', i === idx);
      });
    });
    mobileThumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-index'), 10) || 0;
        mobileCarousel.scrollTo({
          left: idx * mobileCarousel.clientWidth,
          behavior: 'smooth'
        });
      });
    });
  }

  // Popular imágenes de las cards de tipo (Normal/Halter)
  if (DATA.shapes) {
    var nImg = section.querySelector('[data-type-img="normals"]');
    var hImg = section.querySelector('[data-type-img="halters"]');
    if (nImg && DATA.shapes.normal) nImg.innerHTML = '<img src="' + DATA.shapes.normal + '" alt="Tank top normal">';
    if (hImg && DATA.shapes.halter) hImg.innerHTML = '<img src="' + DATA.shapes.halter + '" alt="Tank top halter">';
  }

  // Type toggle
  section.querySelectorAll('.pack-tt-type-card').forEach(function (btn) {
    btn.addEventListener('click', function () {
      section.querySelectorAll('.pack-tt-type-card').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      state.adultType = btn.getAttribute('data-type');
      state.adultProduct = null; state.adultVariant = null;
      var colorLabel = section.querySelector('[data-piece-color="adult"]');
      if (colorLabel) colorLabel.textContent = '';
      renderColors('adult');
      renderAllSizes('adult');
      updateUI();
    });
  });

  // Inicial render
  renderColors('adult');
  renderColors('little');
  renderAllSizes('adult');
  renderAllSizes('little');
  updateUI();

  // Click en CTA
  cta.addEventListener('click', function () {
    if (cta.disabled) return;
    var t = state.adultVariant, b = state.littleVariant;
    if (!t || !b) return;
    cta.disabled = true;
    cta.textContent = 'Agregando...';
    var body = {
      items: [
        { id: parseInt(t.id, 10), quantity: 1,
          properties: { _pack: 'pack-tt', _pack_role: 'adult' } },
        { id: parseInt(b.id, 10), quantity: 1,
          properties: { _pack: 'pack-tt', _pack_role: 'little' } }
      ]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
      .then(function () {
        // Redirigir a /discount/CODE para que Shopify aplique el código y vuelva al cart
        var code = DATA.config.discount_code;
        if (code) {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
        } else {
          // Fallback: abrir cart drawer
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          }, 100);
          cta.disabled = false; cta.textContent = 'Llevar el pack';
        }
      })
      .catch(function (err) {
        console.error('Pack TT add error', err);
        setMsg('No se pudo agregar al carrito. Intentá de nuevo.', true);
        cta.disabled = false; cta.textContent = 'Llevar el pack';
      });
  });
})();
